import { useState } from "react";
import { Modal, ModalHeader, ModalBody, Row, Col, Collapse } from "reactstrap";
// componentes
import SectionComponent from "../../Apps/Personalization/SectionComponent";
import ImportHotel from "./ImportHotel";
import ImportUpdateHotel from "./ImportUpdateHotel";
import ImportDeleteFlight from "./ImportDeleteHotel";

export default function ModalAllImports(props) {
  const { toggle, isOpen, idEvent, data } = props;
  // collapse
  const [collapseCreate, setCollapseCreate] = useState(false);
  const [collapseUpdate, setCollapseUpdate] = useState(false);
  const [collapseDelete, setCollapseDelete] = useState(false);

  function toggleCollapseCreate() {
    setCollapseCreate(!collapseCreate);
    setCollapseUpdate(false);
    setCollapseDelete(false);
  }

  function toggleCollapseUpdate() {
    setCollapseCreate(false);
    setCollapseUpdate(!collapseUpdate);
    setCollapseDelete(false);
  }

  function toggleCollapseDelete() {
    setCollapseCreate(false);
    setCollapseUpdate(false);
    setCollapseDelete(!collapseDelete);
  }

  return (
    <>
      <Modal isOpen={isOpen} centered>
        <ModalHeader toggle={toggle}>Importadores de Hotéis</ModalHeader>
        <ModalBody>
          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Criar Hotéis"
              setIsOpen={toggleCollapseCreate}
              isOpen={collapseCreate}
            />
          </Row>

          <Collapse isOpen={collapseCreate}>
            <ImportHotel toggleModal={toggle} idEvent={idEvent} data={data} />
          </Collapse>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Atualizar Hotéis"
              setIsOpen={toggleCollapseUpdate}
              isOpen={collapseUpdate}
            />
          </Row>

          <Collapse isOpen={collapseUpdate}>
            <ImportUpdateHotel
              toggleModal={toggle}
              idEvent={idEvent}
              data={data}
            />
          </Collapse>

          <Row
            style={{
              display: "flex",
              flexDirection: "row",
              marginBottom: 10,
              width: "245px",
            }}
          >
            <SectionComponent
              sectionName="Deletar Hotéis"
              setIsOpen={toggleCollapseDelete}
              isOpen={collapseDelete}
            />
          </Row>

          <Collapse isOpen={collapseDelete}>
            <ImportDeleteFlight
              toggleModal={toggle}
              idEvent={idEvent}
              data={data}
            />
          </Collapse>
        </ModalBody>
      </Modal>
    </>
  );
}
